<template>
  <div id="app">
    <el-form :model="ruleForm" ref="ruleForm" label-width="0px" class="demo-ruleForm">
      <h5 class="color-white">Leave A Message</h5>
      <el-form-item label="" prop="FullName" required>
        <el-input v-model="ruleForm.FullName" placeholder="Full Name*"></el-input>
      </el-form-item>
      <el-form-item label="" prop="Email" :rules="[
      { required: true, message: 'Email is required', trigger: 'blur' },
      { type: 'email', message: 'Email is required', trigger: ['blur', 'change'] }
    ]" :required=true>
        <el-input v-model="ruleForm.Email" placeholder="Email*"></el-input>
      </el-form-item>
      <el-form-item label="" prop="Subject">
        <el-input v-model="ruleForm.Subject" placeholder="Subject"></el-input>
      </el-form-item>
      <el-form-item label="" prop="Message">
        <el-input type="textarea" style="font-family: 'Open Sans', sans-serif !important;" :autosize="{ minRows: 4, maxRows: 8}" v-model="ruleForm.Message" placeholder="Message"></el-input>
      </el-form-item>
      <el-form-item class="sub-btn">
        <el-button type="primary" :loading=loading :disabled=disableBtn @click="submitForm('ruleForm')">Send</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        disableBtn: false,
        loading: false,
        ruleForm: {
          FullName: '',
          Email: '',
          Subject:'',
          Message:'',
        },
      };
    },
    methods: {
      submitForm(formName) {
        const vm = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            vm.axios.post('https://api.zigi-tech.com/API/Message/sendMessage', vm.ruleForm).then((res) => {
                console.log(res);
                this.$message({
                  type:'success',
                  message:'success'
                });
                this.disableBtn = true;
                this.loading = false;
            });
          } else {
            this.$message({
              type:'error',
              message:'Something required'
            });
            this.disableBtn = false;
            return false;
          }
        }).catch(() => {
          this.$message({
              type:'error',
              message:'Send fail'
            });
        });
      }
    }
  }
</script>

<style>
#app{
  background: transparent;
}
.color-white {
    color: #fff;
}
.sub-btn{
  text-align: center;
}
.sub-btn .el-button{
  width: 100%;
  padding: 14px 30px;
  font-size: 16px;
  background: #106eaa;
}
.form-title{
  margin: 0;
  margin-bottom: 30px;
    border-bottom: 1px solid #D7D7D7;
    font-size: 22px;
    color: #000;
    font-weight: 500;
    font-family: 'Open Sans',"Lucida Grande",Arial,Arimo,Helvetica,sans-serif;
    padding-bottom: 10px;
    position: relative;
}
.demo-ruleForm{
  padding: 20px;
  background: transparent;
}
.title{
  background: #494949;
    border-bottom: 1px solid #EAEAEA;
    margin: 0;
    padding: 20px 25px;
    -webkit-border-radius: 2px 2px 0 0;
    -moz-border-radius: 2px 2px 0 0;
    border-radius: 2px 2px 0 0;
    color: #fff;
    box-sizing: content-box;
}
.upload-demo .el-upload, .el-upload-dragger{
  width: 100%;
}
.el-form-item__label{
  font-weight: 800;
  color: #333;
}
.first-name{
  float: left;
  width: 48%;
  position: relative;
}
.first-name::before{
position: absolute;
bottom: -23px;
left: 2px;
font-size: 12px;
color: #888;
content: 'First';
}
.last-name{
  float: left;
  width: 48%;
  position: relative;
}
.last-name::before{
position: absolute;
bottom: -23px;
left: 2px;
font-size: 12px;
color: #888;
content: 'Last';
}
.cen{
  float: left;
  width: 4%;
  height: 20px;
}
</style>
